import store from '@/store'
import { USER_TOKEN_CACHE_KEY } from './user'

/**
 * 跨标签页登录态同步。
 *
 * 与子站共享 SDK（public/shared/sovi-auth-sdk.js）对称：SDK 监听 `storage` 事件，
 * 对 `USER_TOKEN` 的【任何】变化（写入＝登录、删除＝登出）都刷新子站 UI；主站（本 Vue
 * 应用）此前没有任何 `storage` 监听器，导致「子站登出 → 主站不变」「子站登录 → 主站不变」。
 * 这里补上对称的双向监听（登录 + 登出）。
 *
 * `storage` 事件只在【其它】同源 tab 修改 localStorage 时触发（不会在发起修改的当前 tab
 * 触发），因此本 tab 自己的登录/登出走各自的原有流程，不会与此重复处理。
 */
export function initCrossTabAuthSync() {
    if (typeof window === 'undefined') return

    window.addEventListener('storage', async event => {
        if (event.key !== USER_TOKEN_CACHE_KEY) return

        if (!event.newValue) {
            // 另一个 tab/子站删除了 token（登出）：仅在本 tab 仍认为已登录时才处理，避免无谓 reload。
            // 直接整页刷新，让主站 UI 与受登录态门禁的内容彻底重置（与子站 SDK 的登出 reload 对称）。
            // reload 后本 tab token 已为空、未登录，storage 事件不会自发再触发，无重载循环风险。
            if (store.getters['user/isLoggedIn']) {
                window.location.reload()
            }
        } else {
            // 另一个 tab 写入了 token（登录）：子站直接写 localStorage，不会经过本应用的 Vuex，
            // 因此需要把新 token 同步进 store 再拉取用户信息完成自动登录。
            // 仅在本 tab 当前未登录、且 token 确实变化时才处理，避免对 token 刷新/重写重复触发。
            // 串行 await：先落 token 再拉用户信息，与 user.ts 各登录 action 的写法一致，
            // 减少快速换号时两次 initUserInfo 并发覆盖的窗口。
            if (!store.getters['user/isLoggedIn'] || store.getters['user/token'] !== event.newValue) {
                await store.dispatch('user/setUserToken', event.newValue)
                await store.dispatch('user/initUserInfo')
            }
        }
    })
}
